declare var authenticationMode: any;

var urlConfigs: IUrlConfig;
var irSettings: IRSettings;
if (irSettings) {
    irSettings.displayTimeFormat = irSettings?.usesAmPm ? "hh:mm aa" : "HH:mm";
}
var loggedUser: ILoggedUser;

interface RequestServerParams {
    evt?: any,
    url: string,
    data: any,
    verb?: string,
    showIndicator?: boolean,
    headers?: any,
    dontUpdateFilters?: boolean,
    async?: boolean,
    isAdmin?: boolean,
    dataType?: string,
    contentType?: any, /** bool or string */
    processData?: boolean,
    removeNullProperties?: boolean;

    successFunction: (data: any, e: Event) => void | undefined,
    failureFunction: (textStatus: string, errorThrown: string, errorItem: IError) => void | undefined,
}

let bbAlert = bootbox.alert;
bootbox.alert = function (errorText, callback) {
    if (errorText && errorText !== "") {
        bbAlert(errorText, callback);
    }
}

const ajaxLoadPanel = $('#ajaxSpinnerContainer').dxLoadPanel({
    visible: false,
    showIndicator: true,
    showPane: true,
    shading: false,
    hideOnOutsideClick: false,
    indicatorSrc: urlConfigs.siteRoot + "Content/irng_logo_simple.svg",
    wrapperAttr: {
        id: "irAjaxLoadPanel",
    },
    onShown(e) {
        $("#irAjaxLoadPanel .dx-loadindicator-image").addClass("animate__animated animate__lightSpeedInLeft animate__infinite animate__faster");
    },
    onHidden(e) {
        $("#irAjaxLoadPanel .dx-loadindicator-image").removeClass("animate__animated animate__lightSpeedInLeft animate__infinite animate__faster");
    },
}).dxLoadPanel('instance');

$(document)
    .ajaxStart(function () {
        ajaxLoadPanel?.show();
    })
    .ajaxStop(function () {
        ajaxLoadPanel?.hide();
    });

//Global functions to calculate metric expressions
var ISNULL = function (value, nullValue) {
    return value == null ? nullValue : value;
}

var IIF = function (boolValue, trueValue, falseValue) {
    return boolValue ? trueValue : falseValue;
}

let $fn = $.fn as any;
$fn.animateRotate = function (angle, duration, easing, complete) {
    var args = $.speed(duration, easing, complete) as any;
    var step = args.step;
    return this.each(function (i, e) {
        args.step = function (now) {
            ($ as any).style(e, "transform", "rotate(" + now + "deg)");
            if (step) return step.apply(this, arguments);
        };
        if (angle !== -180) $({ deg: 0 }).animate({ deg: angle }, args);
        else $({ deg: -180 }).animate({ deg: 0 }, args);
    });
};
//SCOTTGAL -\Disabled as we are mjssing this lib.
// dirty hack for bootstrap-tooltip.js, like 253ish, where it screws with titles
/*$.fn.popover.Constructor.prototype.fixTitle = function () {
    var $e = this.$element;
    if ($e.attr('title') || typeof ($e.attr('data-original-title')) != 'string') {
        $e.attr('data-original-title', $e.attr('title') || '');
    }
};
*/

//override the default builtin function because of the wrong currency symbol for some of the currencies
if (!(new Intl.NumberFormat() as any).irng) {
    var NumberFormatOriginal = Intl.NumberFormat;
    (Intl.NumberFormat as any) = function (locale, options: any) {
        return {
            irng: true,
            format: function (number) {
                let scaleSymbol = null;
                if (Object.is(number, -0)) {
                    number = 0;
                }

                if (options) {
                    //there cannot be null properties because they override the default
                    for (var prop in options) {
                        if (options[prop] === null)
                            options[prop] = undefined;
                    }

                    if (options.precision !== undefined && (options.maximumFractionDigits === undefined || options.minimumFractionDigits === undefined)) {
                        options.maximumFractionDigits = options.precision;
                        options.minimumFractionDigits = options.precision;
                    }

                    if (options.largerNumber) {
                        let absValue = Math.abs(number);
                        let format = options.largerNumber;

                        if ((absValue > 1000000000 && format === "Automatic") || format === "Billions") {
                            scaleSymbol = "B";
                            number = number / 1000000000;
                        }
                        else if ((absValue > 1000000 && format === "Automatic") || format === "Millions") {
                            scaleSymbol = "M";
                            number = number / 1000000;
                        }
                        else if ((absValue > 1000 && format === "Automatic") || format === "Thousands") {
                            scaleSymbol = "K";
                            number = number / 1000;
                        }
                    }
                }

                let output = new NumberFormatOriginal(locale, options).format(number);

                if (options) {

                    if (options.largerNumber && scaleSymbol) {
                        if (options.style === "currency") {
                            let decimalOptions = { ...options };
                            decimalOptions.style = "decimal";
                            let simpleValue = new NumberFormatOriginal(locale, decimalOptions).format(number);
                            output = output.replace(simpleValue, `${simpleValue}${scaleSymbol}`);
                        }
                        else {
                            output += scaleSymbol;
                        }
                    }

                    if (options.style === "currency" && options.currencyDisplay === "narrowSymbol" && options.currency) {
                        switch (options.currency) {
                            case "PGK":
                                output = output.replace(options.currency, "K");
                                break;
                            case "AED":
                                output = output.replace(options.currency, "D");
                                break;
                            default:
                                break;
                        }
                    }

                    if (output && options.currencySign === "accounting" && number < 0) {
                        if (options.style === "decimal" || options.style === "percent") {
                            output = `(${output.toString().replace("-", "")})`;
                        }
                    }
                }

                return output;
            }
        };
    }
}

// https://stackoverflow.com/questions/1891444/cursor-position-in-a-textarea-character-index-not-x-y-coordinates
($.fn as any).caret = function (begin, end) {
    if (this.length === 0) return;
    if (typeof begin === 'number') {
        end = (typeof end === 'number') ? end : begin;
        return this.each(function () {
            if (this.setSelectionRange) {
                this.setSelectionRange(begin, end);
            } else if (this.createTextRange) {
                var range = this.createTextRange();
                range.collapse(true);
                range.moveEnd('character', end);
                range.moveStart('character', begin);
                try {
                    range.select();
                } catch (ex) {
                    // do nothing
                }
            }
        });
    } else {
        if (this[0].setSelectionRange) {
            begin = this[0].selectionStart;
            end = this[0].selectionEnd;
        } else if ((document as any).selection && (document as any).selection.createRange) {
            var range = (document as any).selection.createRange();
            begin = 0 - range.duplicate().moveStart('character', -100000);
            end = begin + range.text.length;
        }
        return { begin: begin, end: end };
    }
}

var irGlobal = (function () {
    var hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");

    //Function to convert rgb color to hex format
    function rgb2hex(rgb) {
        rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
        return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }

    function hex(x) {
        return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }

    function splitOnUpper(text) {
        let titleCaseString = text
            .replace(/(_)/g, ' ')
            .trim()
            .replace(/\w\S*/g, function (str) {
                return str.charAt(0).toUpperCase() + str.substr(1)
            })
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/([A-Z])([A-Z][a-z])/g, '$1 $2')

        return titleCaseString;
    }

    var copyTextToClipboard = function (text, message) {
        if (!text) {
            return;
        }

        let fallbackCopyTextToClipboard = function () {
            let textArea = document.createElement("textarea");
            textArea.value = text;

            // Avoid scrolling to bottom
            textArea.style.top = "0";
            textArea.style.left = "0";
            textArea.style.position = "fixed";

            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                let successful = document.execCommand('copy');
                if (successful) {
                    DevExpress.ui.notify(message);
                }
            } catch (err) { }

            document.body.removeChild(textArea);
        };

        if (!navigator.clipboard) {
            fallbackCopyTextToClipboard();
            return;
        }

        navigator.clipboard.writeText(text).then(function () {
            DevExpress.ui.notify(message);
        }, function (err) { });
    };

    var getUpdateButton = function () {
        return getJqueryElement("button#UpdateReport");
    };

    var enableUpdateButton = function (enable, callbackOnClick: Function = undefined) {
        if (isFunction(enable)) enable = enable();
        let updateButton = getUpdateButton() as any;
        updateButton.prop("disabled", !enable);

        //So if we enabled the button and there's something to do if do then enable it.
        if (enable && isFunction(callbackOnClick))
            updateButton.off("click").on("click", callbackOnClick);
    };

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    var debounce = function (func, wait = undefined, immediate = undefined) {
        var timeout;
        return function () {
            var context = this, args = arguments;
            var later = function () {
                timeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    };
    var isLocal = function () {
        return location.hostname === "localhost" || location.hostname === "127.0.0.1";
    };

    var isFunction = function (objectToTest) {
        //Check for null objects...
        if (!objectToTest) return false;
        var getType = {};
        return getType.toString.call(objectToTest) === "[object Function]";

    };

    var changeUrl = function (page, url) {
        //So this will NOT work with browsers which aren't HTML5 friendly
        if (typeof history.pushState === "undefined") return;
        var obj = { Page: page, Url: url };
        history.pushState(obj, obj.Page, obj.Url);

    };
    var shadeColor = function (color, percent) {
        var f = parseInt(color.slice(1), 16),
            t = percent < 0 ? 0 : 255,
            p = percent < 0 ? percent * -1 : percent,
            R = f >> 16,
            G = f >> 8 & 0x00FF,
            B = f & 0x0000FF;
        return "#" +
            (0x1000000 +
                (Math.round((t - R) * p) + R) * 0x10000 +
                (Math.round((t - G) * p) + G) * 0x100 +
                (Math.round((t - B) * p) + B)).toString(16).slice(1);
    };

    var getJqueryElement = function (element) {
        if (!(element instanceof jQuery)) {
            return $(element);
        }
        return element;
    };

    function getRandColor(brightness) {
        //6 levels of brightness from 0 to 5, 0 being the darkest
        var rgb = [Math.random() * 256, Math.random() * 256, Math.random() * 256] as any;
        var mix = [brightness * 51, brightness * 51, brightness * 51]; //51 => 255/5
        var mixedrgb = [rgb[0] + mix[0], rgb[1] + mix[1], rgb[2] + mix[2]]
            .map(function (x) { return Math.round(x / 2.0); });
        rgb = mixedrgb[2] | mixedrgb[1] << 8 | mixedrgb[0] << 16;
        return "#" + rgb.toString(16);
    }

    var showInfo = function (showInfo, infoMessage: string = undefined) {
        let info = $("div.infoDisplay");
        if (info.length === 0) return;
        if (showInfo) {
            info.removeClass("hidden");
            info.addClass("in");
            info.find("p.infoMessage").text(infoMessage);
            info.delay(4000).slideUp(200,
                function () {
                    $(this).addClass("hidden");
                    $(this).removeClass("in");
                    $(this).find("p.message").text("");
                });

        } else {
            info.slideUp(200,
                function () {
                    $(this).addClass("hidden");
                    $(this).removeClass("in");
                    $(this).find("p.message").text("");
                });
        }
    };

    var showError = function (showError: boolean, errorText: string) {
        if (showError && errorText) {
            DevExpress.ui.notify({
                message: errorText,
                position: {
                    my: "center top",
                    at: "center top"
                }
            }, "error", 3000);
        }
    };
    var showToast = function (message: string = undefined, type: string = "success", width: number = 300) {
        if (!message || message === "") {
            return;
        }

        DevExpress.ui.notify({
            message: message,
            position: { my: 'right top', at: 'right top', offset: { x: -20, y: 20 } },
            width: width
        }, type ,3000);
    };
    var notifyError = function (message, align = undefined, yOffset = undefined, element = undefined, from = undefined) {
        notify(message, align, yOffset, "danger", element, from);
    };
    var notify = function (message, align = "right", yOffset = undefined, type = "warning", element = undefined, from = "top") {
        var settings = {
            type: type,
            placement: { align: align, from: from },
            z_index: 9999
        } as any;
        if (yOffset)
            settings.offset = { y: yOffset };
        if (element)
            settings.element = element;

        ($ as any).notify({
            message: message
        }, settings);
    };
    var showYesNoMessage = function (message, callback) {
        bootbox.confirm({
            message: message,
            buttons: {
                confirm: {
                    label: 'Yes',
                    className: 'btn-success'
                },
                cancel: {
                    label: 'No',
                    className: 'btn-danger'
                }
            },
            callback: function (result) {
                callback(result);
            }
        });
    }

    var handleAlerts = function (data) {
        if (data && data.info) {
            showInfo(true, data.info);
        } else {
            showInfo(false);
        }
    };

    //Replace null values by undefined, private properties starting with _, check for observables 
    var jsonReplacer = function replacer(key, value, removeNullProperties: boolean = true) {
        if (key.charAt(0) === "_") {
            return undefined;
        }
        if (value && ko.isObservable(value)) {
            value = value();
        }
        // Filtering out properties
        if (removeNullProperties && value === null) {
            return undefined;
        }
        return value;
    };

    /**
     * Don't serialize null properties, private properties starting with _, check for observables 
     * @param jsonInput Object to serialize
     * @returns
     */
    var jsonStringfy = function (jsonInput, removeNullProperties: boolean = true) {
        return JSON.stringify(jsonInput, (key, value) => { return jsonReplacer(key, value, removeNullProperties); });
    }

    //Contains all ajax requests. 
    var requestServerAdmin = function (e: RequestServerParams) {
        e.isAdmin = true;
        requestServer(e);
    }
    var requestServer = function (e: RequestServerParams) {
        let addErrorLog = function (item: IError) {
            if (workbook?.workbookConfig?.workbookId && workbook.workbookConfig.workbookId() !== 0) {
                let widgetId = workbook.workbookConfig.selectedDashboardWidget?.id() ?? 0;
                if (item.parameters && typeof item.parameters === "string") {
                    const match = item.parameters.match(/"widgetId":\d+/);
                    if (match) {
                        const matchId = match[0].match(/\d+/);
                        if (matchId) {
                            widgetId = parseInt(matchId[0]);
                        }
                    }
                }

                ErrorService.addWorkbookError({
                    workbookTabId: workbook.workbookConfig.activeTab()?.id() ?? 0,
                    widgetId: widgetId,
                    url: item.url,
                    context: "",
                    errorMessage: item.errorMessage,
                    parameters: item.parameters,
                    userMessage: item.userMessage ?? item.errorMessage,
                    stackTrace: item.stackTrace,
                    exception: item.exception
                } as IWorkbookError);
            }

            //if (mapping) {
            //    ErrorService.addMappingError(...)
            //}
        }

        if (e.async === undefined || e.async === null)
            e.async = true;

        if (e.showIndicator === null || e.showIndicator === undefined)
            e.showIndicator = true;

        if (e.processData === null || e.processData === undefined)
            e.processData = true;

        if (e.removeNullProperties === null || e.removeNullProperties === undefined)
            e.removeNullProperties = true;

        if (($.isPlainObject(e.data) || typeof e.data === "object") && !e.isAdmin)
            e.data = jsonStringfy(e.data, e.removeNullProperties);

        let methodVerb = "POST";
        if (e.verb) {
            methodVerb = e.verb;
        }

        let ajaxSettings = {
            url: e.url,
            type: methodVerb,
            data: e.data,
            async: e.async,
            global: e.showIndicator,
            headers: e.headers,
            processData: e.processData
        } as any;

        if (e.dataType) {
            ajaxSettings.dataType = e.dataType;
            ajaxSettings.contentType = "application/json; charset=utf-8";
        }

        if (e.contentType !== undefined) {
            ajaxSettings.contentType = e.contentType;
        }

        let errorItem = {
            url: ajaxSettings.url,
            context: "",
            errorMessage: "",
            parameters: ($.isPlainObject(ajaxSettings.data) || typeof ajaxSettings.data === "object") ? jsonStringfy(ajaxSettings.data) : ajaxSettings.data,
            userMessage: "",
            exception: new Error()
        } as IError;

        $.ajax(ajaxSettings).done(function (data) {
            handleAlerts(data);

            if (data && data.error) {
                errorItem.userMessage = typeof data.error === "string" ? data.error : data.errorMessage;
                addErrorLog(errorItem);
            }

            if (isFunction(e.successFunction)) {
                try {
                    e.successFunction(data, e.evt);
                } catch (errorException) {
                    let failErrorItem = {
                        url: errorItem.url,
                        context: "",
                        errorMessage: errorException,
                        parameters: errorItem.parameters,
                        userMessage: "Something went wrong",
                        exception: errorException
                    } as IError;
                    addErrorLog(failErrorItem);
                    defaultErrorFunction(undefined, "", errorException);
                }
            }
        })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let failureText = errorThrown;
                let status = parseInt(jqXHR.status as any);

                if (status === 401) {
                    location.reload();
                    //loginOnModal(e.evt, e.url, e.data, e.successFunction, e.failureFunction, e.dataType === "json" ? true : false, e.verb, e.showIndicator, e.headers, e.dontUpdateFilters, e.async);
                }
                else {
                    
                    if (jqXHR.responseJSON) {
                        failureText = jqXHR.responseJSON.error;
                    } else if (jqXHR.responseText) {
                        failureText = jqXHR.responseText;
                    }

                    if (failureText && failureText.toString().startsWith("Workbook not found")) {
                        let workbookId = 0;
                        let mt = failureText.match(/-?\d+/i);
                        if (mt && mt.length > 0) {
                            workbookId = parseInt(mt[0], 10);
                        }
                        if (workbookId !== 0) {
                            document.location.href = `${urlConfigs.tabs}WorkbookNotFoundError/${workbookId}`;
                            return;
                        }
                    }

                    errorItem.errorMessage = failureText;

                    if (isFunction(e.failureFunction)) {
                        try {
                            e.failureFunction(textStatus, failureText, errorItem);
                            errorItem.userMessage ??= "Request has failed";
                            addErrorLog(errorItem);
                        } catch (errorException) {
                            let failErrorItem = {
                                url: errorItem.url,
                                context: "",
                                errorMessage: errorException,
                                parameters: errorItem.parameters,
                                userMessage: "Something went wrong",
                                exception: errorException
                            } as IError;
                            addErrorLog(failErrorItem);
                            defaultErrorFunction(undefined, textStatus, failureText, jqXHR);
                        }
                    } else {
                        errorItem.userMessage = "Request has failed";
                        addErrorLog(errorItem);
                        defaultErrorFunction(undefined, textStatus, failureText, jqXHR);
                    }
                }
            });
    }
    var updateFromServer = function (evt, url: string, jsonInput, successFunction: Function, failureFunction: Function = undefined, isJson: boolean = undefined, verb: string = undefined, showIndicator: boolean = undefined, headers = undefined, dontUpdateFilters: boolean = undefined, async: boolean = undefined) {
        requestServer({
            evt: evt,
            url: url,
            data: jsonInput,
            successFunction: successFunction,
            failureFunction: failureFunction,
            dataType: isJson ? "json" : "html",
            verb: verb,
            showIndicator: showIndicator,
            headers: headers,
            dontUpdateFilters: dontUpdateFilters,
            async: async
        } as RequestServerParams);
    };

    function defaultErrorFunction(customMessage: string, textStatus, errorThrown, jqXHR = undefined) {
        if (customMessage && !customMessage.endsWith(".")) {
            customMessage += ". ";
        }

        console.error(customMessage ?? "Error ", textStatus, errorThrown);

                
        if (jqXHR) {
            if (jqXHR.responseJSON && jqXHR.responseJSON.error) {
                showError(true, jqXHR.responseJSON.error);
            }
            else if (typeof jqXHR.responseText === "string" && jqXHR.responseText.startsWith('{"')) {
                let parsed = JSON.parse(jqXHR.responseText);
                if (parsed.error) {
                    showError(true, parsed.error);
                }
                else {
                    showError(true, jqXHR.responseText);
                }
            }
            else if (typeof jqXHR.responseText === "string") {
                showError(true, jqXHR.responseText);
            }
        }
        else {
            showError(true, `${customMessage}${textStatus}`);
        }
    };
    function loginOnModal(evt, url, jsonInput, successFunction, failureFunction, isJson, verb, showIndicator, headers, dontUpdateFilters, async) {
        if (authenticationMode == 'ADFS' || authenticationMode == 'AUTH0') {
            if (workbook?.workbookConfig?.workbookId() < 0) {
                window.location.href = '/home';
            }
            else {
                location.reload();
            }
            return;
        }

        $.ajax({
            url: '/login/?modal=true',
            async: false
        }).done(function (htmlData) {
            let $popup = $('#loginModalPopup');
            if ($popup.length === 0) {
                $("body").append($("<div id='loginModalPopup'>"));
                $popup = $('#loginModalPopup');
            }

            let popup = $('#loginModalPopup').dxPopup({
                contentTemplate() {
                    let element = $(htmlData);

                    var btn = $("#BtnModalLogin", element);
                    $(".centre", element).addClass('top40p');
                    $(this).css('z-index', 99999);

                    $("#showHidePassword").click(function (e) {
                        if ($(".dx-icon", e.currentTarget).hasClass("dx-icon-eyeopen")) {
                            $(".dx-icon", e.currentTarget).removeClass("dx-icon-eyeopen");
                            $(".dx-icon", e.currentTarget).addClass("dx-icon-eyeclose");
                            $("#Password").prop('type', 'text');
                        }
                        else {
                            $(".dx-icon", e.currentTarget).addClass("dx-icon-eyeopen");
                            $(".dx-icon", e.currentTarget).removeClass("dx-icon-eyeclose");
                            $("#Password").prop('type', 'password');
                        }
                    });

                    $(btn).on('click', function (ev) {
                        ev.preventDefault();
                        var divError = $('div.alert', element);
                        $(divError).addClass('hidden');

                        $(btn).attr("disabled", "disabled");

                        let divCompany = $("#drawer .workbook-menu-group.company");
                        let companyId = null;
                        if (divCompany.length > 0) {
                            companyId = parseInt(divCompany.data("id"), 10);
                        }
                        else {
                            divCompany = $(".homeContent span#companySelected");
                            if (divCompany.length > 0) {
                                companyId = parseInt(divCompany.data("id"), 10);
                            }
                        }

                        $.ajax({
                            url: '/login/',
                            type: 'POST',
                            async: false,
                            data: {
                                UserName: $('#UserName', element).val(),
                                Password: $('#Password', element).val(),
                                CompanyId: companyId,
                                IsModal: true,
                                __RequestVerificationToken: $('input[name="__RequestVerificationToken"]', element).val(),
                            }
                        }).done(function (data) {
                            if (data.response == 'OK') {
                                if (workbook?.workbookConfig?.workbookId() < 0) {
                                    window.location.href = '/home';                                   
                                }
                                else {
                                    updateFromServer(evt, url, jsonInput, successFunction, failureFunction, isJson, verb, showIndicator, headers, dontUpdateFilters, async);
                                }
                                popup.hide();
                            }
                            else {
                                $(divError).html(data.response);
                                $(divError).removeClass('hidden');
                                $(btn).removeAttr("disabled");
                                return false;
                            }
                        }).fail(function (jqXHR, textStatus, errorThrown) {
                            $(btn).removeAttr("disabled");
                        });
                    });

                    return element;
                },
                width: 600,
                height: 700,
                showTitle: false,
                visible: false,
                hideOnOutsideClick: false,
                onShown: function (e) {
                    $(".dx-overlay-wrapper").css("z-index", "1049");
                }
            }).dxPopup('instance');
            popup.show();
        });

    }

    var lut = [];
    for (var i = 0; i < 256; i++) {
        lut[i] = (i < 16 ? "0" : "") + i.toString(16);
    }
    function getGuid() {
        var d0 = Math.random() * 0xffffffff | 0;
        var d1 = Math.random() * 0xffffffff | 0;
        var d2 = Math.random() * 0xffffffff | 0;
        var d3 = Math.random() * 0xffffffff | 0;
        return lut[d0 & 0xff] +
            lut[d0 >> 8 & 0xff] +
            lut[d0 >> 16 & 0xff] +
            lut[d0 >> 24 & 0xff] +
            "-" +
            lut[d1 & 0xff] +
            lut[d1 >> 8 & 0xff] +
            "-" +
            lut[d1 >> 16 & 0x0f | 0x40] +
            lut[d1 >> 24 & 0xff] +
            "-" +
            lut[d2 & 0x3f | 0x80] +
            lut[d2 >> 8 & 0xff] +
            "-" +
            lut[d2 >> 16 & 0xff] +
            lut[d2 >> 24 & 0xff] +
            lut[d3 & 0xff] +
            lut[d3 >> 8 & 0xff] +
            lut[d3 >> 16 & 0xff] +
            lut[d3 >> 24 & 0xff];
    }

    var toggleSimpleChevron = function ($button) {
        //Implements a little complete function to set the chevron to the invert.
        $button.animateRotate(180, "fast", function () {
            if ($button.hasClass("glyphicon-chevron-down")) {
                $button.addClass("glyphicon-chevron-up");
                $button.removeAttr("style");
                $button.removeClass("glyphicon-chevron-down");
            } else {
                $button.addClass("glyphicon-chevron-down");
                $button.removeAttr("style");
                $button.removeClass("glyphicon-chevron-up");
            }
        });
    };

    var setupDropdownPosition = function () {
        $(document).off("shown.bs.dropdown").on("shown.bs.dropdown", ".dropdown", function () {
            // calculate the required sizes, spaces
            var $ul = $(this).children(".dropdown-menu");
            var $button = $(this).children(".dropdown-toggle");
            if ($ul.length > 0 && $button.length > 0) {
                var ulOffset = $ul.offset();
                // how much space would be left on the top if the dropdown opened that direction
                var spaceUp = (ulOffset.top - $button.height() - $ul.height()) - $(window).scrollTop();
                // how much space is left at the bottom
                var spaceDown = $(window).scrollTop() + $(window).height() - (ulOffset.top + $ul.height());
                // switch to dropup only if there is no space at the bottom AND there is space at the top, or there isn't either but it would be still better fit
                if (spaceDown < 0 && (spaceUp >= 0 || spaceUp > spaceDown))
                    $(this).addClass("dropup");
            }
        }).on("hidden.bs.dropdown", ".dropdown", function () {
            // always reset after close
            $(this).removeClass("dropup");
        });
    }

    var setup = function () {
        //Very simple way to resize everything when a mobile device changes the orientation. Need to be changed in the future
        window.onorientationchange = function () {
            window.location.reload();
        };

        //DO NOT REMOVE - these are used for various functions throughout the site.
        $(".linkbutton").off("click")
            .on("click",
                function () {
                    window.location.href = $(this).data("href") + "?ReturnUrl=" + window.location.href;
                });


        $(".linkbutton.noreturn").off("click")
            .on("click",
                function () {
                    window.location.href = $(this).data("href");
                });

        setupDropdownPosition();
        $(".modal").on('hidden', function (e) {
            $(this).remove();
        });
        ////////////////////////////////////////////////////////////////////////////////////
    };

    var changePassword = function () {
        Ir.Components.User.ChangePassword.show();
    }

    var setupChangePassword = function () {
        $(document).ready(function () {
            var changePasswordElement = $('#change-password');
            if (changePasswordElement.length > 0) {
                changePasswordElement.on('click', function (e) {
                    e.preventDefault();

                    changePassword();
                });
            }
        });
    }

    var groupBy = function (array, key, isObservable) {
        return array.reduce(function (rv, x) {
            (rv[isObservable ? x[key]() : x[key]] = rv[isObservable ? x[key]() : x[key]] || []).push(x);
            return rv;
        }, {});
    };

    return {
        setup: setup,
        jsonStringfy: jsonStringfy,
        jsonReplacer,
        enableUpdateButton: enableUpdateButton,
        getUpdateButton: getUpdateButton,
        handleAlerts: handleAlerts,
        showError: showError,
        notifyError: notifyError,
        notify: notify,
        debounce: debounce,
        isFunction: isFunction,
        updateFromServer: updateFromServer,
        requestServer: requestServer,
        requestServerAdmin: requestServerAdmin,
        getGuid: getGuid,
        shadeColor: shadeColor,
        getRandomColor: getRandColor,
        rgbToHex: rgb2hex,

        getJqueryElement: getJqueryElement,
        changeUrl: changeUrl,
        showInfo: showInfo,
        isLocal: isLocal,
        //updateOutput: updateOutput,
        //getParentContext: getParentContext,
        getParentContext: () : any => {
            throw new Error('Method removed: irGlobal.getParentContext');
        },
        //getMode: getMode,
        toggleSimpleChevron: toggleSimpleChevron,

        customDate: {
            custom: 50,
            none: 51,
            today: 2,
            all: 32
        },

        splitOnUpper: splitOnUpper,
        showYesNoMessage: showYesNoMessage,
        copyTextToClipboard: copyTextToClipboard,
        setupChangePassword: setupChangePassword,

        //isMobile: function () { return $(window).width() < 960; },
        //isTouchDevice: function () {
        //    return 'ontouchstart' in window ||
        //        navigator.maxTouchPoints > 0 ||
        //        (navigator as any).msMaxTouchPoints > 0;
        //},

        groupBy: groupBy,
        changePassword: changePassword,
        showToast: showToast,
        defaultErrorFunction: defaultErrorFunction
    };
})();

var general = irGlobal;
